import React, { useEffect, useState } from "react";
import Silverlogo from "./Svg/Silverlogo";
import IndianCurrency from "./Svg/IndianCurrency";

const BoxForPrice = ({ Title, Discout = 0, Benifits, Price, MaxPrice, backgroundcolor="#ffe3bb" }) => {
  const [CrossAmount, setCrossAmount] = useState(null);
  const [ActualAmount, setActualAmount] = useState(null);

  useEffect(() => {
    if (Discout > 0) {
      let tempamount = Price - Discout;
      setActualAmount(tempamount);
      setCrossAmount(Price);
    } else {
      setActualAmount(Price);
      setCrossAmount(MaxPrice);
    }
  }, [Price, MaxPrice, Discout]);

  return (
    <div style={{background:backgroundcolor}} className={`pricing-box`}>
      {/* ----top----- */}
      <div className={`pricing-details`}>
        <span className={`packge-name`}>{Title}</span>
        <p className={`packge-para`}>
          Essential for launching a business successfully.
        </p>
        <h6 className={`h6-price`}>
          <span>
            <span>₹</span>
            {Price}
          </span>
          <span className={`del-price`}><del>₹ {MaxPrice}</del></span>
        </h6>
        <a className={`start-trial`}>
          Buy now
          <i className={`normal-arrow fa fa-chevron-right`}></i>
          <i className={`hover-arrow fa fa-arrow-right`}></i>
        </a>
      </div>

      {/* --------details--------- */}
      <div className={`  div-render-parent`}>
        <div
          style={{scrollbarWidth: Benifits!=null? "":"none"}}
          className={`div-for-data-render`}
          dangerouslySetInnerHTML={{ __html: Benifits }}
        ></div>
      </div>
    </div>
  );
};

export default BoxForPrice;
